export const OPENTABLE_REGION_UI_COPY = {
  greeting: {
    login: 'Where is your restaurant located?',
    new_integration: 'Where is your restaurant located?',
  },
  enterprise: {
    prefix: 'If you have more than 20 restaurants,',
    link: 'chat with us about an enterprise plan.',
  },
} as const;
